import { Text } from '@medly-components/core';
import { SliderActionWrapper } from 'components/common/SliderWithActions/SliderActions/SliderActions.styled';
import styled from 'styled-components';

export const ResourcesContainer = styled.div`
    ${SliderActionWrapper} {
        margin-top: 2.4rem;
    }
`;

export const SlidesInfo = styled(Text).attrs({ variant: 'body3' })`
    color: ${({ theme }) => theme.colors.grey[700]};
`;
